import httpClient from 'shared/utils/http-client'
import { EmailTemplateApiInterface } from 'modules/email/types/email-template-interface'

export const EMAIL_API = '/api/dashboard/customer/emails'

export const getEmailTemplates = () =>
  httpClient.get<EmailTemplateApiInterface>(`${EMAIL_API}/templates`)
